/**
 * <Input />
 * 
 * customized text input
 *
 * @parent anybody
 * @stateful
 * @stateless
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'

class Input extends React.Component {
  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(props) {
    super(props);
  }

  componentWillMount() {

  }
  
  render() {
    return (
      <div>
      </div>
    )
  }
}

export default Input;



// WEBPACK FOOTER //
// ./src/shared/RegisterClassModal/Input.js